import reportWidgetConfigBuilder from './report-widget-config-builder';
import cloneDeep from 'lodash/cloneDeep';
import { ReportWidget } from './ReportWidget';

var reportWidget = function reportWidget() {

    var renderWidget = function renderWidget(widgetConfig) {
        var ContainerId = widgetConfig.ContainerId,
            ReportWidgetConfig = widgetConfig.ReportWidgetConfig;


        var el = window.document.querySelector('#' + ContainerId);
        el.className += " ag-theme-material";
        var reportWidget = new ReportWidget(widgetConfig, el);
        reportWidget.render();
    };

    // Initiate rendering for a widget
    var initiateWidgetRendering = function initiateWidgetRendering(configObj) {
        // Get widget specific widgetConfig
        var widgetConfig = reportWidgetConfigBuilder.configBuilder(cloneDeep(configObj));
        renderWidget(widgetConfig);
    };

    return {
        initiateWidgetRendering: initiateWidgetRendering
    };
};

export default reportWidget();